import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateUser } from '@app/shared/models/ecmr/TemplateUser';
import { MatDialogRef } from '@angular/material/dialog';
import { TemplateOverviewService } from '@app/core/services/ecmr-services/template-overview.service';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-load-from-template-dialog',
    templateUrl: './load-from-template-dialog.component.html',
    styleUrl: './load-from-template-dialog.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class LoadFromTemplateDialogComponent implements OnInit {
    dataSource: MatTableDataSource<TemplateUser> =
        new MatTableDataSource<TemplateUser>();
    columnsToDisplay: string[] = ['number', 'name', 'refId', 'from', 'to'];

    selectedTemplate: TemplateUser;

    constructor(
        public dialogRef: MatDialogRef<LoadFromTemplateDialogComponent>,
        public overviewService: TemplateOverviewService,
        public sessionService: SessionService
    ) {}

    ngOnInit(): void {
        this.overviewService
            .getAllTemplates(this.sessionService.currentOrganizationSiteKey())
            .subscribe(data => {
                this.dataSource.data = data;
            });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    loadSelectedTemplate() {
        this.dialogRef.close(this.selectedTemplate);
    }
}
